import { Component, inject } from '@angular/core';
import { AuthStore, BrandApiService, cacTableIdCol } from '@core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { BrandEntity } from '@models';

@Component({
  selector: 'lib-brand',
  imports: [CacTableComponent],
  templateUrl: './brand.component.html',
  styleUrl: './brand.component.scss',
})
export class BrandComponent {
  private readonly brandApi = inject(BrandApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.brandApi.getAdapter(),
    view: { itemName: 'Brand' },
    columns: {
      id: cacTableIdCol(),
      'name.english': { label: 'English Name', sortable: 'EnglishName', filterable: 'EnglishName' },
      'name.arabic': { label: 'Arabic Name', sortable: 'ArabicName', filterable: 'ArabicName' },
      'image.url': { label: 'Logo', type: 'image' },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (brand) => dialog$.brand({ brand }).afterSubmit(),
      },
      ...(!this.authStore.isRestrictedAdmin() ? [{
        type: 'icon' as const,
        content: 'trash',
        action: (item: BrandEntity) => {
          return dialog$.deletePrompt(false, { itemName: item.name.english }).action(() => this.brandApi.delete(item.id));
        },
      }] : []),
    ],

    events: { add: () => dialog$.brand({}).afterSubmit() },
  });
}
